import { render, staticRenderFns } from "./about-contacting-us.vue?vue&type=template&id=0d4086db&scoped=true"
import script from "./about-contacting-us.vue?vue&type=script&lang=js"
export * from "./about-contacting-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4086db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4086db')) {
      api.createRecord('0d4086db', component.options)
    } else {
      api.reload('0d4086db', component.options)
    }
    module.hot.accept("./about-contacting-us.vue?vue&type=template&id=0d4086db&scoped=true", function () {
      api.rerender('0d4086db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/aboutcontacting-managment/about-contacting-us.vue"
export default component.exports